import React from 'react';
import { Globe, ThumbsUp, MessageSquare, Share2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Testimonials() {
  const testimonials = [{
    author: {
      name: 'Mariana L.',
      initial: 'M',
      bgColor: 'bg-[#B8902E]',
      subtitle: 'Contadora · Mamá de 2 · Buenos Aires',
      time: 'Hace 3 h'
    },
    body: <>
          Yo estaba muy angustiada porque mi hijo se frustraba cada vez que
          intentaba leer.
          <br data-id="element-332" />
          <br data-id="element-333" />
          En la escuela le decían que tenía que practicar más, pero cada vez
          quería leer menos.
          <br data-id="element-334" />
          <br data-id="element-335" />
          Probé el Sistema de Lectura en Orden Correcto™ y lo que más me
          sorprendió fue lo simple que es.
          <br data-id="element-336" />
          <br data-id="element-337" />
          <strong data-id="element-338">Primero sonido. Después trazo. Recién ahí palabra.</strong>
          <br data-id="element-339" />
          <br data-id="element-340" />
          En <strong data-id="element-341">10 minutos por día</strong> empezó a entender lo que antes
          le parecía imposible.
          <br data-id="element-342" />
          <br data-id="element-343" />
          Hoy lo veo leer con más confianza y sin llorar, y eso para mí ya vale
          todo.
        </>,
    reactions: {
      likes: '163',
      comments: '21',
      shares: '6'
    },
    comments: [{
      name: 'Carolina R.',
      initial: 'C',
      bgColor: 'bg-[#6B4C9A]',
      text: 'Me pasó exactamente lo mismo con mi hija. Cuando entendió los sonidos todo cambió.'
    }, {
      name: 'Laura M.',
      initial: 'L',
      bgColor: 'bg-[#2E5C31]',
      text: '¿Dónde lo conseguiste? ¡Quiero verlo!'
    }]
  }, {
    author: {
      name: 'Natalia S.',
      initial: 'N',
      bgColor: 'bg-[#D97706]',
      subtitle: 'Docente · Mamá de 1 · Córdoba',
      time: 'Hace 5 h'
    },
    body: <>
          Mi hijo ya estaba empezando a decir "no quiero leer" y eso me
          preocupaba muchísimo.
          <br data-id="element-344" />
          <br data-id="element-345" />
          Sentía que algo no estaba funcionando.
          <br data-id="element-346" />
          <br data-id="element-347" />
          Con el Sistema de Lectura en Orden Correcto™ entendí algo clave:
          muchas veces el problema no es la capacidad del niño, sino el orden en
          que aprende.
          <br data-id="element-348" />
          <br data-id="element-349" />
          Cuando empezamos a trabajar <strong data-id="element-350">sonido → trazo → palabra</strong>,
          todo empezó a tener sentido para él.
          <br data-id="element-351" />
          <br data-id="element-352" />
          En pocas semanas pasó de frustrarse a querer mostrarme lo que podía
          leer.
          <br data-id="element-353" />
          <br data-id="element-354" />
          <strong data-id="element-355">De verdad fue un antes y un después.</strong>
        </>,
    reactions: {
      likes: '198',
      comments: '27',
      shares: '9'
    },
    comments: [{
      name: 'Valeria G.',
      initial: 'V',
      bgColor: 'bg-[#0284C7]',
      text: 'A mi hijo le pasó lo mismo. Este método nos ayudó muchísimo.'
    }, {
      name: 'Andrea P.',
      initial: 'A',
      bgColor: 'bg-[#BE185D]',
      text: '¿Me pasás el link por favor?'
    }]
  }, {
    author: {
      name: 'Sofía M.',
      initial: 'S',
      bgColor: 'bg-[#0F766E]',
      subtitle: 'Administrativa · Mamá de 2 · Rosario',
      time: 'Hace 2 h'
    },
    body: <>
          Yo pensaba que mi hijo simplemente no era bueno para leer.
          <br data-id="element-356" />
          <br data-id="element-357" />
          Cada tarea terminaba en llanto o frustración.
          <br data-id="element-358" />
          <br data-id="element-359" />
          Hasta que encontré el Sistema de Lectura en Orden Correcto™.
          <br data-id="element-360" />
          <br data-id="element-361" />
          Lo que me gustó es que no lleva horas. Son{' '}
          <strong data-id="element-362">10 minutos por día</strong> y está todo explicado{' '}
          <strong data-id="element-363">paso a paso</strong>.<br data-id="element-364" />
          <br data-id="element-365" />
          En casa empezamos a hacerlo como un juego y de a poco empezó a
          reconocer sonidos y formar palabras.
          <br data-id="element-366" />
          <br data-id="element-367" />
          Hoy lo veo mucho más seguro cuando agarra un libro.
          <br data-id="element-368" />
          <br data-id="element-369" />Y eso como mamá es una tranquilidad enorme.
        </>,
    reactions: {
      likes: '174',
      comments: '19',
      shares: '7'
    },
    comments: [{
      name: 'Claudia V.',
      initial: 'C',
      bgColor: 'bg-[#C026D3]',
      text: '¡Lo compré la semana pasada! A mi hijo le está ayudando un montón.'
    }, {
      name: 'María G.',
      initial: 'M',
      bgColor: 'bg-[#B8902E]',
      text: '¿Dónde se consigue?'
    }]
  }];
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-br from-kid-yellow/5 via-background-cream to-kid-pink/5 relative overflow-hidden" data-id="element-370">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-371">
        <FadeIn data-id="element-372">
          <div className="text-center mb-6 md:mb-16" data-id="element-373">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6 uppercase tracking-tight" data-id="element-374">
              LO QUE DICEN OTROS PADRES
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-kid-purple via-kid-pink to-kid-sky mx-auto rounded-full" data-id="element-375"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-376">
          {testimonials.map((post, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-377">
              <div className="bg-white rounded-xl shadow-[0_2px_12px_rgba(0,0,0,0.06)] border border-gray-200 p-4 md:p-5 h-full flex flex-col" data-id="element-378">
                <div className="flex items-center gap-3 mb-3" data-id="element-379">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0 ${post.author.bgColor}`} data-id="element-380">
                    {post.author.initial}
                  </div>
                  <div data-id="element-381">
                    <h3 className="text-[15px] font-bold text-[#050505] leading-tight" data-id="element-382">
                      {post.author.name}
                    </h3>
                    <p className="text-[13px] text-[#65676B] leading-tight mt-0.5" data-id="element-383">
                      {post.author.subtitle}
                    </p>
                    <div className="flex items-center gap-1 text-[13px] text-[#65676B] mt-0.5" data-id="element-384">
                      <span data-id="element-385">{post.author.time}</span>
                      <span data-id="element-386">·</span>
                      <Globe className="w-3 h-3" data-id="element-387" />
                    </div>
                  </div>
                </div>

                <p className="text-[14px] md:text-[15px] text-[#050505] leading-relaxed mb-3 md:mb-4" data-id="element-388">
                  {post.body}
                </p>

                <div className="mt-auto" data-id="element-389">
                  <div className="flex items-center justify-between text-[12px] md:text-[13px] text-[#65676B] pb-2 md:pb-3" data-id="element-390">
                    <div className="flex items-center gap-1.5" data-id="element-391">
                      <div className="flex -space-x-1" data-id="element-392">
                        <span className="text-base md:text-lg leading-none z-20" data-id="element-393">
                          👍
                        </span>
                        <span className="text-base md:text-lg leading-none z-10" data-id="element-394">
                          ❤️
                        </span>
                        <span className="text-base md:text-lg leading-none z-0" data-id="element-395">
                          😮
                        </span>
                      </div>
                      <span data-id="element-396">
                        A {post.reactions.likes} personas les gusta esto
                      </span>
                    </div>
                    <div data-id="element-397">
                      {post.reactions.comments} comentarios ·{' '}
                      {post.reactions.shares} compartidos
                    </div>
                  </div>

                  <hr className="border-[#CED0D4]" data-id="element-398" />

                  <div className="flex items-center justify-between py-1" data-id="element-399">
                    <button className="flex-1 flex items-center justify-center gap-1.5 md:gap-2 py-1 md:py-1.5 rounded-md hover:bg-gray-50 text-[#65676B] font-semibold text-[13px] md:text-[14px] transition-colors" data-id="element-400">
                      <ThumbsUp className="w-4 h-4 md:w-5 md:h-5" data-id="element-401" />
                      <span data-id="element-402">Me gusta</span>
                    </button>
                    <button className="flex-1 flex items-center justify-center gap-1.5 md:gap-2 py-1 md:py-1.5 rounded-md hover:bg-gray-50 text-[#65676B] font-semibold text-[13px] md:text-[14px] transition-colors" data-id="element-403">
                      <MessageSquare className="w-4 h-4 md:w-5 md:h-5" data-id="element-404" />
                      <span data-id="element-405">Comentar</span>
                    </button>
                    <button className="flex-1 flex items-center justify-center gap-1.5 md:gap-2 py-1 md:py-1.5 rounded-md hover:bg-gray-50 text-[#65676B] font-semibold text-[13px] md:text-[14px] transition-colors" data-id="element-406">
                      <Share2 className="w-4 h-4 md:w-5 md:h-5" data-id="element-407" />
                      <span data-id="element-408">Compartir</span>
                    </button>
                  </div>

                  <hr className="border-[#CED0D4] mb-2 md:mb-3" data-id="element-409" />

                  <div className="space-y-2 md:space-y-3" data-id="element-410">
                    {post.comments.map((comment, cIdx) => <div key={cIdx} className="flex items-start gap-2" data-id="element-411">
                        <div className={`w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center text-white font-bold text-xs md:text-sm flex-shrink-0 mt-0.5 md:mt-1 ${comment.bgColor}`} data-id="element-412">
                          {comment.initial}
                        </div>
                        <div className="bg-[#F0F2F5] rounded-[18px] px-3 py-1.5 md:py-2 max-w-[calc(100%-2.5rem)]" data-id="element-413">
                          <div className="text-[12px] md:text-[13px] font-bold text-[#050505] mb-0.5" data-id="element-414">
                            {comment.name}
                          </div>
                          <div className="text-[13px] md:text-[15px] text-[#050505] leading-snug" data-id="element-415">
                            {comment.text}
                          </div>
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}